import { EvtStatsCard } from "components/stats/display-card";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";
import QueryError from "components/query-error";
import React from "react";
import { formatHoursToTime } from "components/timesheet/utils";
import { useMilestoneConsumedHours } from "components/milestone/stats/consumed/useMilestoneConsumedHours";

export const MilestoneTotalConsumedHoursStat = ({ id, dateRange }) => {
  const { data, isLoading, isError, refetch, error } =
    useMilestoneConsumedHours(id, dateRange);

  if (isLoading) {
    return <EvtStatsCardPlaceholder />;
  }

  if (isError) {
    return (
      <QueryError message="Failed to load Approved hours." onRetry={refetch} />
    );
  }

  return <EvtStatsCard label="Consumed" value={formatHoursToTime(data)} />;
};
